import React from 'react'
import { GraviGrid, Texto, Vertical } from '@gravitate-js/excalibrr'
import type { ColDef } from 'ag-grid-community'
import type { SupplierMetrics } from '../types'
import { TerminalIconRenderer } from './TerminalIconRenderer'
import { TerminalInvoiceCountRenderer } from './TerminalInvoiceCountRenderer'
import { TerminalBOLCountRenderer } from './TerminalBOLCountRenderer'
import { TerminalNameCellRenderer } from './TerminalNameCellRenderer'

const terminalColumnDefs: ColDef[] = [
  {
    headerName: '',
    field: 'terminalName',
    maxWidth: 20,
    cellRenderer: TerminalIconRenderer,
    pinned: 'left',
  },
  {
    headerName: 'Terminal',
    field: 'terminalName',
    flex: 2,
    minWidth: 160,
    pinned: 'left',
    cellRenderer: TerminalNameCellRenderer,
  },
  {
    headerName: 'Invoices',
    field: 'invoiceCount',
    width: 60,
    flex: 0,
    // pinned: 'right',
    cellStyle: { textAlign: 'center' },
    cellRenderer: TerminalInvoiceCountRenderer,
  },
  {
    headerName: 'BOLs',
    field: 'bolCount',
    width: 60,
    flex: 0,
    // pinned: 'right',
    cellStyle: { textAlign: 'center' },
    cellRenderer: TerminalBOLCountRenderer,
  },
  {
    headerName: 'Past Due',
    field: 'pastDueAmount',
    width: 100,
    flex: 0,
    // pinned: 'right',
    cellStyle: { textAlign: 'right', fontWeight: 'bold' },
    valueFormatter: (params) => {
      const amount = params.value || 0
      return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
  },
]

export function TerminalDetailRenderer(props: { data: SupplierMetrics; context?: any }) {
  const { data: supplierData, context } = props

  // Data preparation with validation
  const detailData = React.useMemo(() => {
    if (!supplierData || !Array.isArray(supplierData.terminalBreakdown)) {
      return []
    }
    return supplierData.terminalBreakdown.filter((terminal) => terminal && typeof terminal === 'object')
  }, [supplierData])

  // Calculate grid height based on actual row count
  function getGridHeight(terminals: any[]) {
    const headerHeight = 32
    const rowHeight = 30
    const totalRows = terminals.length
    return headerHeight + totalRows * rowHeight + 40 // 40px for padding
  }

  if (detailData.length === 0) {
    return <Texto> No terminal data available</Texto>
  }

  return (
    <Vertical style={{ height: getGridHeight(detailData) }}>
      <GraviGrid
        primaryKey='terminalId'
        rowData={detailData}
        columnDefs={terminalColumnDefs}
        sideBar={undefined}
        agPropOverrides={{
          headerHeight: 32,
          rowHeight: 50,
          pagination: false,
          suppressPaginationPanel: true,
          rowGroupPanelShow: 'onlyWhenGrouping',
          scrollbarWidth: 0,
          suppressHorizontalScroll: false,
          animateRows: true,
          getRowId: (params) => params.data.terminalId,
          context: {
            ...context,
            supplierName: supplierData?.supplierName,
          },
        }}
      />
    </Vertical>
  )
}
